import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBpYVPxOz9RvGnh-AdBoDsCZCHYhp2qzgg",
  authDomain: "fir-demo-3b0f3.firebaseapp.com",
  databaseURL: "https://fir-demo-3b0f3.firebaseio.com",
  projectId: "fir-demo-3b0f3",
  storageBucket: "fir-demo-3b0f3.appspot.com",
  messagingSenderId: "516217541475",
  appId: "1:516217541475:web:f3a49da71133957bde7956",
  measurementId: "G-S2Q80LEVQ1"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
